/**
 * Admin API
 * Admin REST API
 *
 * OpenAPI spec version: 1.0
 * Contact: ti@b4agroup.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface SubscriberPaymentStep {
  creditCardPaymentId?: number;
  dateCreated?: Date;
  dateUpdated?: Date;
  lastMessage?: string;
  origin?: SubscriberPaymentStep.OriginEnum;
  paymentRoundId?: number;
  priority?: number;
  step?: SubscriberPaymentStep.StepEnum;
  subscriberId?: number;
}
export namespace SubscriberPaymentStep {
  export type StepEnum =
    | 'VALIDATION'
    | 'PAYMENT'
    | 'ACTIVATION'
    | 'SUBSCRIBER_EDITION'
    | 'FINISHED';
  export const StepEnum = {
    VALIDATION: 'VALIDATION' as StepEnum,
    PAYMENT: 'PAYMENT' as StepEnum,
    ACTIVATION: 'ACTIVATION' as StepEnum,
    SUBSCRIBEREDITION: 'SUBSCRIBER_EDITION' as StepEnum,
    FINISHED: 'FINISHED' as StepEnum
  };
  export type OriginEnum =
    | 'BENEFIT_ASSIGNMENT'
    | 'RENEWAL_ROBOT'
    | 'CARD_UPDATE'
    | 'REPROCESSING'
    | 'CHECKOUT'
    | 'TEST_CARD'
    | 'PIX_RECORRENTE';
  export const OriginEnum = {
    BENEFITASSIGNMENT: 'BENEFIT_ASSIGNMENT' as OriginEnum,
    RENEWALROBOT: 'RENEWAL_ROBOT' as OriginEnum,
    CARDUPDATE: 'CARD_UPDATE' as OriginEnum,
    REPROCESSING: 'REPROCESSING' as OriginEnum,
    CHECKOUT: 'CHECKOUT' as OriginEnum,
    TESTCARD: 'TEST_CARD' as OriginEnum,
    PIXRECORRENTE: 'PIX_RECORRENTE' as OriginEnum
  };
}
